// Articles eligible for the WrongArticle experiment with their short descriptions
export const WRONG_ARTICLE_DATA: Record<string, string> = {
  '0b5999dd-e2d7-44a9-b730-acb2fb8637f8':
    'Set up an email address you purchased from a different provider to work with your Wix website.',
  'e72873df-9108-4665-a12b-6b077e9d453f':
    'Connect a domain you already own to your site by updating its name servers.',
  '9445b407-f0fb-4ad2-bcb9-5e2f5bf43042':
    'Discover how Wix templates help you design your own website.',
  'f5d95194-d6f0-40b8-b1e1-da69eb496071':
    'Add, edit, or remove DNS records to control how your site and email are connected.',
  '9ca50d2c-7da0-4007-8ec6-00b91994198d':
    'Connect Google Analytics to your site and track visitor actions and events.',
  'c61857c1-9b9f-48f8-ae8b-c46c74427ec8':
    'Publish your Wix site and make it live for everyone to see.',
  '060690b0-7d7b-4aa5-b1a6-3962dd30748c':
    "Use SEO settings to update default SEO details for all your site's pages in one place.",
  'a015e0b1-5bd3-45b3-8431-b9adc4270e06':
    'Create and share pay links to collect payments from your customers online.',
  '4b4f163b-6523-45a9-af38-a832714c4dca':
    'Move a domain you own elsewhere from one Wix account to another by disconnecting and reconnecting it.',
  '6101ea89-007d-475b-8c57-62a1b7cf884d':
    'Compare RSVP and ticketed events to choose the best way for guests to register or buy tickets for your event.',
  '4a72c650-767a-4344-b6da-c59df84ad89c':
    'Invite others to help build, edit, or manage your site by sending them a collaborator invitation.',
  'c52ea67f-6348-42da-a372-105483401492':
    'See how dynamic pages help you manage content efficiently, giving every item in your collection its own page automatically.',
  'f3388913-140f-47a9-b2ba-4bf86b60e04e':
    'Set up a 301 redirect to send visitors from an old page URL to a new one without losing site traffic or search rankings.',
  'b3b8fc42-237b-49dd-9d73-ea26cd075925':
    "Understand your Wix Site Inspection report so you can identify, address, and monitor issues that impact your site's search performance.",
  'e6d51c6f-fe20-4484-a9f5-ea95e8dbd356':
    'Track and manage site changes by viewing your site history, restoring previous versions, or checking updates made by collaborators.',
  '88f9af56-d2c4-47e7-8d9c-3d831da6f5f5':
    'Connect a domain you bought from another provider so it connects to your Wix site or transfer it for complete Wix management.',
  '2a80c066-8f86-459f-85ef-c59d0128ffcd':
    'Move your domain to Wix to manage your settings, billing, and DNS all in one place',
  '8d62a3cd-3a66-4a94-a97c-22c4d7e44524':
    'Move your premium site to another Wix account and bring your domain along for a seamless transfer of ownership.',
  '93269015-9304-4f05-9cc4-1380967c0a87':
    'Connect your existing domain to Wix using the pointing method to keep managing your domain where you bought it.',
  'a85fe243-6375-49a1-b825-1b8c8717005e':
    'Connect your Wix domain to your site if it was unassigned or not linked automatically.',
  '05dd2271-6b88-427d-b5c5-b19dbb42e69c':
    'For domains hosted outside Wix, authenticate your email domain to improve deliverability and use your brand in emails.',
  'cccc4fe5-22e7-4368-803e-c3f91b22daac':
    'Customize your automated emails to match your brand, set your sender details, and choose who receives each email.',
  'b9cf3df0-18ab-4733-b5cc-44167e8adf84':
    'Move your domain from Wix to a new host if you want to manage settings and renewals elsewhere.',
  '7dd4c6d1-a6be-4f78-8389-8dc67b3d6ad4':
    'Add custom code to your Wix site to track analytics, verify ownership, or add third-party features.',
  'a5791a34-e170-4419-b4bb-f5ff46b34ae7':
    'Find out what to expect if you dispute a Wix charge, including service cancellation and next steps.',
  '5358847b-2d40-4fb7-bb04-b562b91758e7':
    'Move your Premium plan to another site in your Wix account when you need premium features there.',
  '73aff516-f611-4f73-84fd-992406d1fec7':
    'Create a custom QR code you can share anywhere, so people can scan it and get in touch with you quickly.',
  '2bb89960-cefe-44e0-9a49-27088a433240':
    'Purchase a custom business email for your domain so you can send and receive messages with your branded address.',
  'b984be3b-3991-4e09-a8ec-1ff099712873':
    "Add an image to your event page so guests can see what it's all about.",
  '189b7792-d554-4ca2-a421-766efc36dfe7':
    "Find out why some email campaigns don't reach your contacts and how to keep your messages from bouncing.",
  'afb542b0-31bb-48ca-81af-bf0d78066027':
    'Solve Google Workspace domain errors by verifying your ownership in your Wix account.',
  '8d883fce-d980-40da-9d77-908ba942d13c':
    "Check and organize your Wix media storage to avoid running out of space for your site's files.",
  '0d811e58-a17b-4b5e-a489-cd1fc824cdf9':
    'Learn which products and services are not allowed with Wix Payments so you can avoid account issues or payment holds.',
  'c0e9d86c-bde7-4bc0-95f1-fba042101fc5':
    'Learn the difference between name servers and pointing so you can pick the right domain connection for your needs.',
  'd0d2dc25-b1ff-4b73-a445-e64015195d4a':
    'Connect PayPal in Wix Payments so that customers can pay you with PayPal, with all payments processed through your Wix Payments account.',
  'e8060165-4831-421e-999d-b2b49aa08b6f':
    'Customize your form fields to ensure your forms gather the details you need from site visitors.',
  '1baa5e2a-fb0e-4122-9528-46956f87a07c':
    "Start fresh with a new template to update your site's look and feel.",
  'aefd4fe8-1079-4eca-a09c-969a5cc0ea21':
    'Give your customers choices by adding product options like size, color, or style to your store items.',
  'b1d66914-9073-43d1-af55-f923aac621b0':
    'Offer your services or content through customizable pricing plans and memberships.',
  '4ed4abd9-b5d6-4df9-93ec-b3d75e2cff64':
    'Bring all your emails, messages, and chats into Wix Inbox so you never miss a conversation.',
  '0824359b-331c-4b7a-be2f-db8c86a3df61':
    'Make your site forms stand out by customizing design, colors, and fields.',
  '8ec212e3-114d-4b8c-9e1e-ec5634b20cb8':
    'Display outside sites or interactive features on your page with embed code or URLs.',
  'f52c15d8-9109-4986-84d9-b2f26fd7818b':
    'Move your domain to another Wix account when you need to change ownership or use it on another project.',
  '9a3b078b-78bd-4582-942e-0800f3bda9ed':
    'Verify your domain on Facebook if you want to track events using the Meta pixel or run ads.',
  '11f57f02-90c1-4970-8f62-aa17d40b9f6a':
    "Connect your Gmail account to Wix Inbox so your site's emails come from your own address.",
};

export const getWrongArticleDescription = (articleId: string): string | null =>
  WRONG_ARTICLE_DATA[articleId] || null;

export const isWrongArticleEligible = (articleId: string): boolean =>
  articleId in WRONG_ARTICLE_DATA;
